// OrderPrintableContent.js
import React from 'react';
import { formatDateTime } from '../../services/UtilityService';
import { DELI_TYPE_DEFINE, DELI_TYPES, ORDER_ID_LENGTH, ORDER_ID_PREFIX } from '../../constants/commonConstants';

export function OrderReceiptContent({ customerName, orderCartData, orderTotal, orderId, date, deliType, discount = 0, deliFee = 0, serviceCharge = 0, tipMoney = 0 }) {
    // const discountedTotal = orderTotal - discount;
    const finalTotal = orderTotal + serviceCharge + tipMoney + deliFee - discount;

    const getDeliveryFee = () => {
        const deliTypeValue = parseInt(deliType) || null;
        const deliFeeShow = deliTypeValue === DELI_TYPE_DEFINE.prepaidDelivery.value ? `¥${deliFee}` : DELI_TYPES.find(deli => deli.value === deliTypeValue)?.text;
        return deliFeeShow;
    }

    return (
        <div className="orderPrintContent">
            <div style={{ textAlign: 'center', marginBottom: '10px' }}>
                <img
                    crossOrigin="anonymous"
                    src="/BT-Icon.png"
                    alt="Logo"
                    style={{
                        width: '70px',
                        height: 'auto',
                        marginBottom: '5px',
                        borderRadius: '50%',
                        border: '1px solid #999'
                    }}
                />
                <div style={{ fontSize: '16px', fontWeight: 'bold' }}>Beauty Treasures</div>
            </div>
            {/* <div style={{ textAlign: 'center' }}>Customer: {customerName}</div> */}
            {/* <div style={{ textAlign: 'center' }}>Order ID: {ORDER_ID_PREFIX}-{String(orderId).padStart(ORDER_ID_LENGTH, '0')}</div>
            <div style={{ textAlign: 'center' }}>Date: {formatDateTime(date?.slice(0, 8))}</div> */}

            <table style={{ margin: '0 auto', textAlign: 'right' }}>
                <tbody>
                    <tr><td>Order ID:</td><td style={{ paddingLeft: '10px', textAlign: 'left' }}>{ORDER_ID_PREFIX}-{String(orderId).padStart(ORDER_ID_LENGTH, '0')}</td></tr>
                    <tr><td>Date:</td><td style={{ paddingLeft: '10px', textAlign: 'left' }}>{formatDateTime(date?.slice(0, 8))}</td></tr>
                    <tr><td>Customer:</td><td style={{ paddingLeft: '10px', textAlign: 'left' }}>{customerName}</td></tr>
                </tbody>
            </table>
            <hr />
            {orderCartData.map((item, idx) => (
                <div key={idx} style={{ marginBottom: '8px' }}>
                    <strong>{item.brandName?.trim()} </strong>
                    <strong>{item.productName?.trim()} </strong>
                    {(item.color || item.size) && (
                        <>
                            {item.color && <strong>({item.color?.trim()}) </strong>}
                            {item.size && <strong>({item.size?.trim()}) </strong>}
                        </>
                    )}
                    <strong>[{item.categoryName}] </strong>
                    <br />
                    Qty: {item.orderedQuantity} x ¥{item.salePrice} = ¥{item.orderedQuantity * item.salePrice}
                    <hr />
                </div>
            ))}
            <table style={{ marginLeft: 'auto', textAlign: 'right' }}>
                <tbody>
                    <tr><td>Subtotal:</td><td style={{ paddingLeft: '10px' }}>¥{orderTotal || 0}</td></tr>
                    <tr><td>Delivery:</td><td style={{ paddingLeft: '10px' }}>{getDeliveryFee()}</td></tr>
                    {serviceCharge > 0 && <tr><td>Service Charge:</td><td style={{ paddingLeft: '10px' }}>¥{serviceCharge || 0}</td></tr>}
                    {tipMoney > 0 && <tr><td>Tip Money:</td><td style={{ paddingLeft: '10px' }}>¥{tipMoney || 0}</td></tr>}
                    {discount > 0 && <tr><td>Discount:</td><td style={{ paddingLeft: '10px' }}>-¥{discount || 0}</td></tr>}
                    <tr style={{ fontWeight: 'bold' }}><td>Total:</td><td style={{ paddingLeft: '10px' }}>¥{finalTotal || 0}</td></tr>
                </tbody>
            </table>
            <div style={{ textAlign: 'center', marginTop: '1rem' }}>✨ Thank you! ✨</div>
        </div>
    );
}